import { withStyles } from '@material-ui/core';
import { LabeledToggle } from '../../../../../common/MUI';
import { weekdaysShortName } from '../../../../Settings/Optimization/AnchorPoint/addUpdateAnchorPoint/DayOfWeekStatus/Constants';

const styles = (theme) => ({
  container: {
    marginTop: 24,
  },
  headerText: {
    marginBottom: 8,
    color: theme.iconColor,
    fontSize: theme.fontSize,
    fontWeight: 500,
    lineHeight: 'normal'
  },
  toggleContainer: {
    maxWidth: '60%' 
  }
});

const DOWDeliveryWindow = ({ classes, deliveryDays, onDeliveryDaysChange }) => {
  const handleDeliveryDayToggle = (isEnabled, meta) => {
    const updatedDeliveryDays = [...deliveryDays];
    updatedDeliveryDays[meta.index] = { 
      name: meta.dayOfWeek.name, 
      value: isEnabled 
    };
    onDeliveryDaysChange(updatedDeliveryDays);
  };

  return (
    <div className={classes.container}>
      <div className={classes.headerText}>DELIVERY DAYS</div>
      {deliveryDays.map((dayOfWeek, index) => (
        <LabeledToggle
          key={dayOfWeek.name}
          label={dayOfWeek.name}
          checked={dayOfWeek.value}
          meta={{ dayOfWeek, index }}
          onChange={handleDeliveryDayToggle}
          labelFormatter={(label) => `${label} (${weekdaysShortName[label.toLowerCase()]})`}
          classes={{
            container: classes.toggleContainer
          }}
        />
      ))}
    </div>
  );
};

export default withStyles(styles)(DOWDeliveryWindow);
